import * as React from "react";
import { DialogActions as MUIDialogActions, styled } from "@mui/material";

const DialogActionContainer = styled(MUIDialogActions)(({ theme }) => ({
  "&.MuiDialogActions-root": {
    padding: theme.spacing(2, 3),
    "& button:not(:first-of-type)": {
      marginLeft: theme.spacing(1),
    },
  },
}));

export default DialogActionContainer;
